export default __webpack_public_path__ + "static/media/daniel.e8cc18ee.jpg";